import { Button, Col, Row, Checkbox } from "antd";
import { InputOTP } from 'antd-input-otp';
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Config from "../../../Config";

import "./mrtt_client_screen.css";
import GeneralBloc from "../../../bloc/general_bloc";
import { ReactComponent as ProposalIcon } from "../../../Proposal2.svg";
import { ReactComponent as DeclarationIcon } from "../../../Declaration.svg";
import { ReactComponent as SignIcon } from "../../../Draft.svg";
import AppStandardDetailsCard from "../../component/app_quotation_card/app_standard_details_card";
import AppCollapse from "../../component/app_collapse/app_collapse";
import ClientBloc from "../../../bloc/client_bloc";
import AppGeneratedDocumentsDetailsCard from "../../component/app_quotation_card/app_generated_documents_card2";
import AppMobileLoading from "../../dialog/app_mobile_loading";
import moment from "moment";

class ReviewProposal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            idNo: null,
        };
        sessionStorage.removeItem('collectInformation');
    }

    componentDidMount() {
        this.initiateData();
    }

    getProposalId() {
        return this.props.match.params.itemId;
    }

    async initiateData() {
        this.setState({ loading: true });
        let result = await ClientBloc.getQuotationAndProposalDetails(this.getProposalId());
        console.log('hello', result)
        this.setState({ formDetails: result, loading: false });
    }

    stateFormDetails() {
        return this.state.formDetails;
    }

    handleGoNext() {
        window.location.replace(`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_declaration}/${this.getProposalId()}`);
    }

    loadingContent() {
        return (
            <div style={{ height: "100%" }}>
                <AppMobileLoading
                    isLoading={this.state.loading}
                />
            </div>
        );
    }

    stepHeader() {
        return (
            <>
                <div className="column d-flex align-items-center justify-content-center">
                    <div className="d-flex row pr-2" style={{ textAlign: '-webkit-center' }}>
                        <div className="align-items-center justify-content-center">
                            <div className="process_step">
                                <ProposalIcon fill={'#FFFFFF'} style={{ height: 24, width: 24 }} />
                            </div>
                            <div className="">Proposal</div>
                        </div>

                    </div>
                    <div className="line_through_process" ></div>
                    <div className="d-flex row pr-2" style={{ textAlign: '-webkit-center' }}>
                        <div className="align-items-center justify-content-center">
                            <div className="pending_step">
                                <DeclarationIcon fill={'#9599B6'} style={{ height: 24, width: 24 }} />
                            </div>
                            <div className="">Declaration</div>
                        </div>

                    </div>
                    <div className="line_through_process"></div>
                    <div className="d-flex row p-2" style={{ textAlign: '-webkit-center' }}>
                        <div className="align-items-center justify-content-center">
                            <div className="pending_step">
                                <SignIcon fill={'#9599B6'} style={{ height: 24, width: 24 }} />
                            </div>
                            <div className="">Signature</div>
                        </div>

                    </div>
                </div>
            </>
        )
    }

    renderTableHeader() {
        return (
            <div className="mt-3">
                <div className="row d-flex m-0 table-header-container align-items-center ">
                    <div className="" style={{ width: '4%' }}>Yes</div>
                    <div className="" style={{ width: '4%' }}>No</div>
                    <div className="" style={{ width: '23%' }}>Medical Condition</div>
                    <div className="" style={{ width: '12%' }}>Date of Diagnosis</div>
                    <div className="" style={{ width: '20%' }}>Treatment Prescribed</div>
                    <div className="" style={{ width: '14%' }}>Attending Doctor{'\''}s Name</div>
                    <div className="" style={{ width: '18%' }}>Attending Doctor{'\''}s Address </div>
                </div>
            </div>
        )
    }

    renderTableBody(data) {
        return (
            <div className="row d-flex m-0 align-items-center table-body-container app-standard-content-field-content">
                <div className="" style={{ width: '4%' }}>
                    <Checkbox
                        className={'disabledCheckedBox disabledTick'}
                        disabled
                        checked={data.checked == 'Yes'}
                    />
                </div>
                <div className="" style={{ width: '4%' }}>
                    <Checkbox
                        className="disabledCheckedBox disabledTick"
                        disabled
                        checked={data.checked == 'No'}
                    />
                </div>
                <div className="" style={{ width: '23%' }}>
                    {data?.condition}
                </div>
                <div className="" style={{ width: '12%' }}>
                    {data?.dateOfDiagnosis && moment(data?.dateOfDiagnosis).format('DD/MM/YYYY')}
                </div>
                <div className="pt-1" style={{ width: '20%' }}>
                    {data?.treatment}
                </div>
                <div className="pt-1" style={{ width: '14%' }}>
                    {data?.doctorName}
                </div>
                <div className="pt-1" style={{ width: '18%' }}>
                    {data?.doctorAddress}
                </div>
            </div>
        )
    }

    renderExtendedHealthData(data) {
        return (
            <div >
                <Row className=''>
                    <Col className="col-lg-6 col-sm-12 mb-4">
                        <div className="app-content-field-tag">{data.q1.caption}</div>
                        <div className="app-standard-content-field-content">{data.q1.value}</div>
                    </Col>
                    <Col className="col-lg-6 col-sm-12 mb-4">
                        <div className="app-content-field-tag">{data.q2.caption}</div>
                        <div className="app-standard-content-field-content"> {data.q2.value}</div>
                    </Col>

                </Row>
                <Row className='mb-4'>
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q3.caption}</div>
                        <div className="app-standard-content-field-content">{data.q3.value}</div>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col className="col-lg-12 col-sm-12" >
                        <div className="app-content-field-tag">{data.q4.caption}</div>
                        <div style={{ overflowX: 'scroll' }} >
                            <div className="mt-2" style={{ width: '850px' }}>
                                {this.renderTableHeader()}
                                {
                                    data?.q4 && data.q4.value.map((item) => {
                                        return (
                                            this.renderTableBody(item)
                                        )
                                    })
                                }
                            </div>
                        </div>

                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q5.caption}</div>
                        <div style={{ overflowX: 'scroll' }} >
                            <div className="mt-2" style={{ width: '850px' }}>
                                {this.renderTableHeader()}
                                {
                                    data?.q5 && data.q5.value.map((item) => {
                                        return (
                                            this.renderTableBody(item)
                                        )
                                    })
                                }
                            </div>
                        </div>

                    </Col>
                </Row>
                <Row className="ml-0 mb-4">
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q6.caption}</div>
                        <div style={{ overflowX: 'scroll' }} >
                            <div className="mt-2" style={{ width: '850px' }}>
                                {this.renderTableHeader()}
                                {
                                    data?.q6 && data.q6.value.map((item) => {
                                        return (
                                            this.renderTableBody(item)
                                        )
                                    })
                                }
                            </div>
                        </div>

                    </Col>
                </Row>
                <Row className="ml-0 mb-4">
                    <Col className="col-lg-12 col-sm-12">
                        <div className="app-content-field-tag">{data.q7.caption}</div>
                        <div style={{ overflowX: 'scroll' }} >
                            <div className="mt-2" style={{ width: '850px' }}>
                                {this.renderTableHeader()}
                                {
                                    data?.q7 && data.q7.value.map((item) => {
                                        return (
                                            this.renderTableBody(item)
                                        )
                                    })
                                }
                            </div>
                        </div>

                    </Col>
                </Row>
                <Row className="ml-0">
                    <Col className="col-lg-12 col-sm-12 mb-3">
                        <div className="app-content-field-tag">{data.q8.caption}</div>
                        <div className="mt-2">
                            {data.q8.value}
                        </div>
                    </Col>
                    {
                        data?.q8 && data.q8.value == 'Yes' &&
                        <Col className="col-lg-12 col-sm-12 ml-3 mb-4">
                            <div className="app-content-field-tag">{data.q8a.caption}</div>
                            <div className="mt-2">
                                {data.q8a.value + ' months'}
                            </div>
                        </Col>
                    }

                </Row>
            </div>
        )
    }

    renderBottomBar() {
        return (
            <div className="bottom_container d-flex justify-content-center">
                <Button
                    style={{
                        backgroundColor: '#183028',
                        color: 'white',
                        width: '100%',
                        height: 49,
                    }}
                    onClick={() => this.handleGoNext()}
                >
                    Next
                </Button>
            </div>
        )
    }

    render() {
        return (
            <div className="client_container" style={{ height: '100%' }}>
                {this.state.loading && this.loadingContent()}
                <div className="mobile_container d-fkex justify-content-center" style={{ height: window.innerHeight, overflowY: 'scroll' }}>
                    <div className="client_header">
                        Review and Sign
                    </div>

                    {this.renderBottomBar()}
                    <div className="d-flex justify-content-center p-4 row w-100 m-0">
                        {this.stepHeader()}
                        <div className="mt-4 " style={{ paddingBottom: 150 }}>
                            {this.stateFormDetails()?.personalDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.personalDetails) && (
                                <AppStandardDetailsCard
                                    data={this.stateFormDetails().personalDetails}
                                    fields={
                                        Config.proposal.mobileDataDetailMapping.personalDetails ||
                                        []
                                    }
                                    header={Config.proposal.formDataMapping.step1.personalDetailsTitle}
                                />
                            )}
                            {this.stateFormDetails()?.mortgageDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.mortgageDetails) && (
                                <AppStandardDetailsCard
                                    data={this.stateFormDetails().mortgageDetails}
                                    fields={
                                        Config.proposal.mobileDataDetailMapping.mortgageDetails ||
                                        []
                                    }
                                    header={Config.proposal.formDataMapping.step1.mortgageDetailsTitle}
                                />
                            )}
                            {this.stateFormDetails()?.healthStatement && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.healthStatement) && (
                                <AppStandardDetailsCard
                                    data={this.stateFormDetails().healthStatement}
                                    fields={
                                        Config.proposal.mobileDataDetailMapping.healthStatement ||
                                        []
                                    }
                                    header={Config.proposal.formDataMapping.step1.healthStatementTitle}
                                />
                            )}
                            {this.stateFormDetails()?.directCredit && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.directCredit) && (
                                <AppStandardDetailsCard
                                    data={this.stateFormDetails().directCredit}
                                    fields={
                                        Config.proposal.mobileDataDetailMapping.directCreditDetails ||
                                        []
                                    }
                                    header={Config.proposal.formDataMapping.step1.directCreditDetailsTitle}
                                />
                            )}
                            {this.stateFormDetails()?.extendedHealthDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.extendedHealthDetails) && (
                                <>
                                    <AppCollapse
                                        header={Config.proposal.formDataMapping.step1.extendedHealthDeclarationTitle}
                                    >
                                        {this.renderExtendedHealthData(this.stateFormDetails()?.extendedHealthDetails)}
                                    </AppCollapse>
                                </>

                            )}
                            {this.stateFormDetails()?.foreignerDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.foreignerDetails) && (
                                <AppStandardDetailsCard
                                    data={this.stateFormDetails().foreignerDetails}
                                    fields={
                                        Config.proposal.mobileDataDetailMapping.foreigner ||
                                        []
                                    }
                                    header={Config.proposal.formDataMapping.step1.foreignQuestionaireTitle}
                                />
                            )}
                            {this.stateFormDetails()?.generalOccDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.generalOccDetails) && (
                                <AppStandardDetailsCard
                                    data={this.stateFormDetails().generalOccDetails}
                                    fields={
                                        Config.proposal.mobileDataDetailMapping.generalOcc ||
                                        []
                                    }
                                    header={Config.proposal.formDataMapping.step1.generalOccupationTitle}
                                />
                            )}
                            {this.stateFormDetails()?.oilGasDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.oilGasDetails) && (
                                <AppStandardDetailsCard
                                    data={this.stateFormDetails().oilGasDetails}
                                    fields={
                                        Config.proposal.mobileDataDetailMapping.oilAndGasOcc ||
                                        []
                                    }
                                    header={Config.proposal.formDataMapping.step1.oilGasTitle}
                                />
                            )}
                            {this.stateFormDetails()?.resTravelDetails && !GeneralBloc.isObjectEmpty(this.stateFormDetails()?.resTravelDetails) && (
                                <AppStandardDetailsCard
                                    data={this.stateFormDetails().resTravelDetails}
                                    fields={
                                        Config.proposal.mobileDataDetailMapping.residentialForeignTravel ||
                                        []
                                    }
                                    header={Config.proposal.formDataMapping.step1.residentailForeignTravelTitle}
                                />
                            )}
                            {this.stateFormDetails()?.generatedDocuments && (
                                <AppGeneratedDocumentsDetailsCard
                                    title={'Uploaded Documents'}
                                    module={'proposal'}
                                    width={'90%'}
                                    data={this.stateFormDetails().generatedDocuments}
                                    proposalId={this.getProposalId()}
                                    mobile={true}
                                />
                            )}
                            {/* {
                                this.state.generateDoc && this.state.generateDoc?.data?.length > 0 &&
                                <AppUploadedDocumentsDetailsCard
                                    module={'proposal'}
                                    data={this.state.generateDoc}
                                />
                            } */}

                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
});

export default withRouter(connect(mapStateToProps)(ReviewProposal));
